import React from 'react';

import CorporateOnlineJoiningWizard from 'src/components/online-joining/corporate';
import OnlineJoiningContextProvider from 'src/components/online-joining/online-joining-context-provider';
import type { OnlineJoiningLocation } from 'src/components/online-joining/online-joining-location';
import { unwrapOnlineJoiningCmsRecordFromPageQuery } from 'src/content/cms-provider/online-joining-cms-provider';
import { OnlineJoiningCmsContent } from 'src/content/online-joining-content';
import { JourneyType } from 'src/enums/journey-type';

type LegacyTdrCapitalPageContentProps = {
  location?: OnlineJoiningLocation;
  data: Queries.CorporateTdrJoinOnlinePageContentQuery;
};

const LegacyTdrCapitalPageContent: React.FC<LegacyTdrCapitalPageContentProps> = ({
  location,
  data,
}) => {
  const cmsContent = unwrapOnlineJoiningCmsRecordFromPageQuery(data);

  return (
    <OnlineJoiningCmsContent.Provider value={cmsContent}>
      <OnlineJoiningContextProvider journeyType={JourneyType.TDR_CAPITAL}>
        <CorporateOnlineJoiningWizard location={location} />
      </OnlineJoiningContextProvider>
    </OnlineJoiningCmsContent.Provider>
  );
};

export default LegacyTdrCapitalPageContent;
